import { Box, Link, Image } from '@chakra-ui/react';
import React, { useState } from 'react';
import { BurgerMenu } from '../../Icons/BurgerMenu';
import CreatedByEmperia from '../../assets/images/CreatedByEmperia.png';
import CreatedByEmperiaAR from '../../assets/images/CreatedByEmperiaAR.png';
import { Info } from '../../Icons/Info';
import { OverlayProps } from '../../interfaces/components';
import { Lavender } from '../../Icons/Lavender';
import RoomItem from './RoomItem';
import { Immortale } from '../../Icons/Immortale';
import { Almond } from '../../Icons/Almond';
import { SheaButter } from '../../Icons/SheaButter';
import { BackToStart } from '../../Icons/BackToStart';
import { Sound } from '../../Icons/Sound';
import { SoundDisabled } from '../../Icons/SoundDisabled';
import { LoccitaneClose } from '../../Icons/LoccitaneClose';
import { ToEng } from '../../Icons/ToEng';
import { ToArabic } from '../../Icons/ToArabic';
import { OverlayMenu } from '../../content';

const Overlay = ({
  activeLocale,
  setLocale,
  toggleInstructions,
  lavenderCollected,
  immortalleCollected,
  almondCollected,
  sheaButterCollected,
  playTransitionVideo,
  audioActive,
  toggleAudio,
  resetAudioToHub,
}: OverlayProps) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [cartOpen, setCartOpen] = useState(false);

  const shiftLocale = (tpUpdateLocale: string) => {
    setLocale(tpUpdateLocale);
    // const url = new URL(window.location.href);
    // const params = url.searchParams;
    // params.set('locale', tpUpdateLocale);
    // url.search = params.toString();
    // const newURl = url.toString();
    // console.log(newURl);
  };

  return (
    <Box className="layout">
      {/* Menu Open Button */}
      <BurgerMenu
        boxSize={[8, 9, 9, 10]}
        position="fixed"
        top={['15px', '20px', '30px']}
        left={['15px', '20px', '30px']}
        cursor="pointer"
        borderRadius="100%"
        stroke="#CCCCCC"
        _hover={{ filter: 'drop-shadow(-2px 0px 2px #FFF736) drop-shadow(2px 0px 4px #FFCB00)', stroke: 'black' }}
        transition="0.5s"
        onClick={() => setMenuOpen(true)}
      />

      {/* Drawer */}
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={menuOpen ? 1 : 0}
        visibility={menuOpen ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.1)"
        transition="all 1s"
        zIndex={4}
        onClick={() => setMenuOpen(false)}
      />
      <Box
        position="fixed"
        opacity={menuOpen ? 1 : 0}
        visibility={menuOpen ? 'visible' : 'hidden'}
        transition="all .5s"
        bg="white"
        top={['5px', '5px', '15px', '15px']}
        left={['5px', '5px', '15px', '15px']}
        width={['250px', '270px', '300px', '300px', '300px']}
        height={['360px', '420px', '450px', '450px', '450px']}
        borderRadius="20px"
        boxShadow="rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
        padding={['10px', '15px', '15px', '15px', '15px']}
        zIndex={5}
      >
        <Box display="flex" justifyContent="flex-start" alignItems="center">
          <LoccitaneClose
            boxSize={[8, 9, 9, 10]}
            cursor="pointer"
            strokeWidth={0.5}
            zIndex={30}
            stroke="#CCCCCC"
            borderRadius="100%"
            _hover={{ filter: 'drop-shadow(-2px 0px 2px #FFF736) drop-shadow(2px 0px 4px #FFCB00)', stroke: 'black' }}
            transition=".5s"
            onClick={() => setMenuOpen(false)}
          />
        </Box>
        <Box
          w={['200px', '210px', '210px', '210px', '210px']}
          h={['190px', '210px', '230px', '230px', '230px']}
          m="0 auto"
          mt={['20px']}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexDirection="column"
        >
          <RoomItem
            activeLocale={activeLocale}
            alignRight={false}
            onClick={() => {
              playTransitionVideo('lavender', 'lavender_0');
              setMenuOpen(false);
            }}
            icon={
              <Lavender
                boxSize={[8, 10, 10, 10]}
                borderRadius="100%"
                filter={
                  lavenderCollected
                    ? 'drop-shadow(-2px 0px 2px #E7BFFF) drop-shadow(2px 0px 4px #6C65C2)'
                    : 'drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.15))'
                }
                fill={lavenderCollected ? 'black' : '#CCCCCC'}
                transition="0.5s"
              />
            }
            itemText={
              activeLocale === undefined || !((activeLocale as keyof typeof OverlayMenu) in OverlayMenu)
                ? OverlayMenu['en'].lavender
                : OverlayMenu[activeLocale as keyof typeof OverlayMenu].lavender
            }
          />
          <RoomItem
            activeLocale={activeLocale}
            alignRight={false}
            onClick={() => {
              playTransitionVideo('immortelle', 'immortelle_0');
              setMenuOpen(false);
            }}
            icon={
              <Immortale
                boxSize={[8, 10, 10, 10]}
                borderRadius="100%"
                filter={
                  immortalleCollected
                    ? 'drop-shadow(-2px 0px 2px #FFF736) drop-shadow(2px 0px 4px #FFCB00)'
                    : 'drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.15))'
                }
                fill={immortalleCollected ? 'black' : '#CCCCCC'}
                transition="0.5s"
              />
            }
            itemText={
              activeLocale === undefined || !((activeLocale as keyof typeof OverlayMenu) in OverlayMenu)
                ? OverlayMenu['en'].immortelle
                : OverlayMenu[activeLocale as keyof typeof OverlayMenu].immortelle
            }
          />
          <RoomItem
            activeLocale={activeLocale}
            alignRight={false}
            onClick={() => {
              playTransitionVideo('almond', 'almond_0');
              setMenuOpen(false);
            }}
            icon={
              <Almond
                boxSize={[8, 10, 10, 10]}
                borderRadius="100%"
                filter={
                  almondCollected
                    ? 'drop-shadow(-2px 0px 2px #A9F58F) drop-shadow(2px 0px 4px #55AB36)'
                    : 'drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.15))'
                }
                fill={almondCollected ? 'black' : '#CCCCCC'}
                transition="0.5s"
              />
            }
            itemText={
              activeLocale === undefined || !((activeLocale as keyof typeof OverlayMenu) in OverlayMenu)
                ? OverlayMenu['en'].almond
                : OverlayMenu[activeLocale as keyof typeof OverlayMenu].almond
            }
          />
          <RoomItem
            activeLocale={activeLocale}
            alignRight={false}
            onClick={() => {
              playTransitionVideo('shea', 'shea_0');
              setMenuOpen(false);
            }}
            icon={
              <SheaButter
                boxSize={[8, 10, 10, 10]}
                borderRadius="100%"
                filter={
                  sheaButterCollected
                    ? 'drop-shadow(-2px 0px 2px #B06C36) drop-shadow(2px 0px 4px #B09155)'
                    : 'drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.15))'
                }
                fill={sheaButterCollected ? 'black' : '#CCCCCC'}
                transition="0.5s"
              />
            }
            itemText={
              activeLocale === undefined || !((activeLocale as keyof typeof OverlayMenu) in OverlayMenu)
                ? OverlayMenu['en'].shea
                : OverlayMenu[activeLocale as keyof typeof OverlayMenu].shea
            }
          />
        </Box>
        <Box
          w={['200px', '210px', '210px', '210px', '210px']}
          h={['80px', '100px', '100px', '100px', '100px']}
          m="0 auto"
          mt={['20px']}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexDirection="column"
        >
          <RoomItem
            activeLocale={activeLocale}
            alignRight={true}
            onClick={() => {
              resetAudioToHub();
              setMenuOpen(false);
            }}
            divider={false}
            rightIcon={false}
            icon={
              <BackToStart
                boxSize={[8, 10, 10, 10]}
                cursor="pointer"
                borderRadius="100%"
                boxShadow="rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                fill="black"
                transition="0.5s"
              />
            }
            itemText={
              activeLocale === undefined || !((activeLocale as keyof typeof OverlayMenu) in OverlayMenu)
                ? OverlayMenu['en'].toStart
                : OverlayMenu[activeLocale as keyof typeof OverlayMenu].toStart
            }
          />
          <RoomItem
            activeLocale={activeLocale}
            alignRight={true}
            onClick={() => {
              toggleInstructions();
              setMenuOpen(false);
            }}
            divider={false}
            rightIcon={false}
            icon={
              <Info
                boxSize={[8, 10, 10, 10]}
                cursor="pointer"
                borderRadius="100%"
                boxShadow="rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                fill="black"
                transition="0.5s"
              />
            }
            itemText={
              activeLocale === undefined || !((activeLocale as keyof typeof OverlayMenu) in OverlayMenu)
                ? OverlayMenu['en'].instructions
                : OverlayMenu[activeLocale as keyof typeof OverlayMenu].instructions
            }
          />
        </Box>
      </Box>

      {/* Top Right Floating Button */}
      <BackToStart
        boxSize={[8, 9, 9, 10]}
        position="fixed"
        top={['15px', '20px', '30px']}
        right={['15px', '20px', '30px']}
        cursor="pointer"
        borderRadius="100%"
        fill="#CCCCCC"
        boxShadow="rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
        _hover={{ filter: 'drop-shadow(-2px 0px 2px #FFF736) drop-shadow(2px 0px 4px #FFCB00)', fill: 'black' }}
        transition="0.5s"
        onClick={() => resetAudioToHub()}
      />

      {/* Cart Box */}
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={cartOpen ? 1 : 0}
        visibility={cartOpen ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.1)"
        transition="all 1s"
        zIndex={4}
        onClick={() => setCartOpen(false)}
      />

      {activeLocale === 'ar' ? (
        <ToEng
          boxSize={[8, 9, 9, 10]}
          position="fixed"
          bottom={['55px', '65px', '75px', '80px', '80px']}
          left={['15px', '20px', '30px']}
          cursor="pointer"
          borderRadius="100%"
          fill="#CCCCCC"
          stroke="#CCCCCC"
          _hover={{
            filter: 'drop-shadow(-2px 0px 2px #FFF736) drop-shadow(2px 0px 4px #FFCB00)',
            fill: 'black',
            stroke: 'black',
          }}
          transition="0.5s"
          onClick={() => shiftLocale('en')}
        />
      ) : (
        <ToArabic
          boxSize={[8, 9, 9, 10]}
          position="fixed"
          bottom={['55px', '65px', '75px', '80px', '80px']}
          left={['15px', '20px', '30px']}
          cursor="pointer"
          borderRadius="100%"
          fill="#CCCCCC"
          stroke="#CCCCCC"
          _hover={{
            filter: 'drop-shadow(-2px 0px 2px #FFF736) drop-shadow(2px 0px 4px #FFCB00)',
            fill: 'black',
            stroke: 'black',
          }}
          transition="0.5s"
          onClick={() => shiftLocale('ar')}
        />
      )}

      {/* Left Bottom Floating Buttons */}
      {audioActive ? (
        <Sound
          boxSize={[8, 9, 9, 10]}
          position="fixed"
          bottom={['15px', '20px', '30px']}
          left={['15px', '20px', '30px']}
          cursor="pointer"
          borderRadius="100%"
          fill="#CCCCCC"
          stroke="#CCCCCC"
          _hover={{
            filter: 'drop-shadow(-2px 0px 2px #FFF736) drop-shadow(2px 0px 4px #FFCB00)',
            fill: 'black',
            stroke: 'black',
          }}
          transition="0.5s"
          onClick={toggleAudio}
        />
      ) : (
        <SoundDisabled
          boxSize={[8, 9, 9, 10]}
          position="fixed"
          bottom={['15px', '20px', '30px']}
          left={['15px', '20px', '30px']}
          cursor="pointer"
          borderRadius="100%"
          fill="#CCCCCC"
          stroke="#CCCCCC"
          _hover={{
            filter: 'drop-shadow(-2px 0px 2px #FFF736) drop-shadow(2px 0px 4px #FFCB00)',
            fill: 'black',
            stroke: 'black',
          }}
          transition="0.5s"
          onClick={toggleAudio}
        />
      )}

      {/* Created By Emperia Link */}
      <Link href="https://emperiavr.com/" target="_blank">
        <Box position="fixed" bottom={['15px', '20px', '25px']} right={['15px', '20px', '25px']} cursor="pointer">
          <Image
            loading="lazy"
            src={activeLocale === 'ar' ? CreatedByEmperiaAR : CreatedByEmperia}
            width={['150px', '150px', '200px', '200px', '200px', '200px']}
          />
        </Box>
      </Link>
    </Box>
  );
};

export default Overlay;
